import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import { getDecryptedAccessToken, getDecryptedData, getDecryptedUserType } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import ExerciseDetails from "./ExerciseDetails"; // Import ExerciseDetails component

const Exercises = () => {
  const params = useParams();
  const accessToken = getDecryptedAccessToken();
  const LoginUserDetails = getDecryptedData();
  const LoginUserType = getDecryptedUserType();
  const pid = LoginUserType === "Patient" ? LoginUserDetails?.pid : params.pid;

  const [groupedExercises, setGroupedExercises] = useState({});
  const [selectedDate, setSelectedDate] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (pid) {
      const apiUrl =
        LoginUserType === "Patient"
          ? `/apis/default/portal/patient/exercises/${pid}`
          : `/apis/default/api/patient/exercises/${pid}`;

      ApiServices.get(apiUrl, {
        Authorization: `Bearer ${accessToken}`,
      })
        .then((response) => {
          const exercises = response.data;
          const today = new Date().toISOString().split("T")[0]; // Current date in YYYY-MM-DD format

          // Group exercises by date
          const groupedData = exercises.reduce((acc, exercise) => {
            const { date } = exercise;
            if (!acc[date]) {
              acc[date] = { pastDate: date < today, exercises: [] };
            }
            acc[date].exercises.push(exercise);
            return acc;
          }, {});

          setGroupedExercises(groupedData);
          setSelectedDate(getDefaultDate(groupedData, today)); // Set default selected date
        })
        .catch((error) => {
          console.error("API Error:", error);
        })
        .finally(() => setLoading(false));
    }
  }, [pid, accessToken]);

  // Function to get default selected date
  const getDefaultDate = (data, today) => {
    if (data[today]) return today; // If exercises exist for today, select today

    const pastDates = Object.keys(data).filter((date) => date < today).sort().reverse();
    return pastDates.length > 0 ? pastDates[0] : null; // Select the closest past date
  };

  return (
    <Box sx={{ p: 2 }}>
      {loading ? (
        <Typography sx={{ textAlign: "center", mt: 3 }}>Loading exercises...</Typography>
      ) : Object.keys(groupedExercises).length === 0 ? (
        <Typography sx={{ textAlign: "center", mt: 3, fontWeight: "bold", color: "gray" }}>
          No exercises assigned yet
        </Typography>
      ) : (
        <>
          {/* Scrollable Tabs Wrapper */}
          <Box
            sx={{
              width: "100%",
              overflowX: "auto",
              whiteSpace: "nowrap",
              scrollbarWidth: "none", // Hide scrollbar for Firefox
              "&::-webkit-scrollbar": { display: "none" }, // Hide scrollbar for Chrome, Safari
              borderBottom: "1px solid #ddd",
            }}
          >
            <Tabs
              value={selectedDate}
              onChange={(event, newValue) => setSelectedDate(newValue)}
              variant="scrollable"
              scrollButtons="auto"
              sx={{ bgcolor: "#f5f5f5", borderRadius: 2 }}
            >
              {Object.keys(groupedExercises).map((date) => (
                <Tab
                  key={date}
                  label={date}
                  value={date}
                  sx={{
                    fontWeight: "bold",
                    textTransform: "none",
                    color: groupedExercises[date].pastDate ? "gray" : "black",
                  }}
                />
              ))}
            </Tabs>
          </Box>

          {/* Exercise Details Section */}
          {selectedDate && groupedExercises[selectedDate] && (
            <ExerciseDetails
              exercises={groupedExercises[selectedDate].exercises}
              pastDate={groupedExercises[selectedDate].pastDate}
            />
          )}
        </>
      )}
    </Box>
  );
};

export default Exercises;
